import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';
import { Deposito } from 'src/app/models/cad/deposito/deposito';

@Injectable({
  providedIn: 'root'
})
export class DepositoService extends AbstractIdbaService {

  override model: Deposito;

  constructor(http: HttpClient) {
    super(http, new Deposito());
    this.programName = "cad/deposito/deposito.p";
  }

  pesquisarPorNome(nomeDeposito: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar";
    request.parameters = { nomeDeposito };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }




}
